import React from "react";
import { Container, Col, FormGroup, Row, Form, Button } from "react-bootstrap";
import { MainHeader, Breadcrumb, MainFooter, ImageElement } from "../../components";
import { Input, Select } from 'antd';
import TextArea from "antd/lib/input/TextArea";
import { Link } from "react-router-dom";

function ContactUs() {
    const breadcrumb = [
        {
            path: '/Home',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Contact Us',
        },
    ];
    return (
        <>       
            <MainHeader/>
            <main className="aboutPage">
                <Container>
                    <Breadcrumb title="Contact Us" breadcrumb={breadcrumb}/>
                    <div className="aboutPage_inner">
                        <div className="text-center">
                            <h2 className="aboutPage_title mt-0 mb-0">Welcome to Good Guys Home Service, the easiest to get around at the tap of a button.</h2>
                        </div>
                        <div className="aboutPage_form mx-auto w-100">
                            <Form>
                                <Row>
                                    <Col sm={6}>
                                        <FormGroup className="form-group">
                                            <label className="ant-label">First Name</label>
                                            <Input size="large" placeholder="First Name" />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={6}>
                                        <FormGroup className="form-group">
                                            <label className="ant-label">Last Name</label>
                                            <Input size="large" placeholder="Last Name"/>
                                        </FormGroup>
                                    </Col>
                                    <Col sm={6}>
                                        <FormGroup className="form-group">
                                            <label className="ant-label">Email</label>
                                            <Input type="email" size="large" placeholder="Email"/>
                                        </FormGroup>
                                    </Col>
                                    <Col sm={6}>
                                        <FormGroup className="form-group form-group-number">
                                                <label className="ant-label">Mobile Number</label>
                                                <div className="position-relative">
                                                    <Input size="large" value="" placeholder="Number" />
                                                    <div className="form-cstm position-absolute top-0 left-0 d-flex">
                                                        <Select size="large" className="w-100" placeholder="+91"
                                                            options={[
                                                                {
                                                                    value: '+91',
                                                                    label: '+91',
                                                                },
                                                                {
                                                                    value: '+1',
                                                                    label: '+1',
                                                                }
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                            </FormGroup>
                                    </Col>
                                    <Col sm={12}>
                                        <FormGroup className="form-group">
                                            <label className="ant-label">Subject</label>
                                            <Input size="large" placeholder="Enter Subject Here"/>
                                        </FormGroup>
                                    </Col>
                                    <Col sm={12}>
                                        <FormGroup className="form-group">
                                            <label className="ant-label">Please Enter Details</label>
                                            <TextArea size="large" placeholder="Please Enter Details"/>
                                        </FormGroup>
                                    </Col>
                                    <Col sm={12}>                                    
                                        <FormGroup className="form-group">
                                            <h3 className="aboutPage_form_capthead">Enter Captcha<span className="text-650">*</span></h3>
                                            <Row className="align-items-center g-0">
                                                <Col xs={8} sm={6}><Input size="large"/></Col>
                                                <Col xs={4} sm={6}><div className="aboutPage_form_captxt">Gh3gjs</div></Col>
                                            </Row>
                                        </FormGroup>
                                    </Col>
                                    <Col sm={12}>
                                        <FormGroup className="form-group">
                                            <div className="aboutPage_form_link">
                                                Can’t read the image? <Link to="/contact-us">Click here</Link>
                                            </div>                                        
                                        </FormGroup>
                                    </Col>
                                    <Col sm={12} className="text-center">
                                        <Button variant="primary" className="ms-auto min-200">Submit</Button>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </div>
                </Container>
            </main>
            <MainFooter/>
        </>
    );
  }
  
  export default ContactUs;